import { styled } from '@mui/material/styles';
import { PostFormData } from '@buildwise/pages/addPost/hooks/useAddPostForm';
import { Box, IconButton, Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import LinkIcon from 'remixicon-react/LinkIcon';
import { VIEW_ARTICLE } from 'constants/routes';
import CloseCircleFillIcon from 'remixicon-react/CloseCircleFillIcon';
import { theme } from 'config/theme';
import { useCallback, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import {
  ArticleRelatedRecordType,
  ArticleType,
} from '@buildwise/pages/knowledge/hooks/useArticlesQuery';

type ArticleRelatedRecordsProps = {
  relatedRecords?: ArticleRelatedRecordType[];
};

function ArticleRelatedRecords({ relatedRecords }: ArticleRelatedRecordsProps) {
  return (
    <Box my={1}>
      <Typography
        sx={(theme) => ({ color: theme.palette.custom.tuna, fontSize: 16, fontWeight: 700, mb: 1 })}
      >
        Linked Posts
      </Typography>
      {relatedRecords?.map((record) => (
        <Box
          {...{
            component: Link,
            to: VIEW_ARTICLE.replace(':articleId', record.recordId),
          }}
          sx={(theme) => ({
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            width: 'fit-content',
            gap: 1,
            my: 1,
            color: theme.palette.custom.link,
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
              color: theme.palette.custom.link,
            },
          })}
        >
          <LinkIcon size={18} />
          <Typography
            sx={(theme) => ({
              color: 'inherit',
              fontSize: 16,
              fontWeight: 700,
            })}
          >
            {record.recordTitle}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default ArticleRelatedRecords;
